import { Component, EventEmitter, Input, OnDestroy, Output, inject } from "@angular/core";

import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonicModule, Platform } from "@ionic/angular";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { TranslateModule } from "@ngx-translate/core";
import { NewBaseService } from "@providers/newBase.service";
import { SportsFormatTitleEventPipe } from "@sports-pipes/index";
import { SportsExtractDatePipe } from "@sports-pipes/sports.extract-date.pipe";
import { SportsFormatOddPipe } from "@sports-pipes/sports.format-odd.pipe";
import { SportsParseMoneyPipe } from "@sports-pipes/sports.parse-money.pipe";
import { C_NodeTicket } from "@ticket/models";
import { Subject, of, switchMap, takeUntil } from "rxjs";

@Component({
  selector: "my-bet-ticket",
  templateUrl: "./my-bet-ticket.html",
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    SportsParseMoneyPipe,
    SportsFormatOddPipe,
    SportsExtractDatePipe,
    SportsFormatTitleEventPipe,
  ],
  styleUrls: ["./my-bet-ticket.scss"],
})
export class MyBetTicketComponent implements OnDestroy {
  @Input() ticket: C_NodeTicket;
  @Input() globalVars: GlobalVarsModel;
  @Input() token: string;
  @Output() selectBet: EventEmitter<any> = new EventEmitter();
  @Output() cashout: EventEmitter<any> = new EventEmitter();
  router = inject(Router);
  newBaseService = inject(NewBaseService);
  isDesktop = false;
  isMobile = false;

  platform = inject(Platform);

  private readonly unsubscribe$ = new Subject();

  constructor() {
    this.isDesktop = this.platform.is("desktop");
    this.isMobile = this.platform.is("mobile");

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();
  }

  openBetDetail(ticketNumber: string, betResult) {
    betResult.show = !betResult.show;

    if (betResult.show) {
      const betSelected = {
        ticketNumber: ticketNumber,
        dateTicket: this.ticket,
      };
      this.selectBet.emit(betSelected);
    }
  }

  payOutTicket(ticketNumber, result) {
    const params = {
      ticketNumber: ticketNumber,
      result: result,
    };
    this.cashout.emit(params);
  }

  checkStatusCode(obj: object, value: number): boolean {
    if (obj !== undefined && obj !== null && "StatusCode" in obj) {
      return obj.StatusCode === value;
    } else return false;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
